import { useRef } from 'react';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import IconButton from '@mui/material/IconButton';
import styled from '@mui/material/styles/styled';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import PropTypes from 'prop-types';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main,
      fontSize: '0.95em',
      fontWeight: '600',
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
      fontSize: '0.95em',
      fontWeight: '600',
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
      fontSize: '0.95em',
      fontWeight: '600',
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main,
      fontSize: '0.95em',
      fontWeight: '600',
    },
  })
);

const ToastProvider = ({ children }) => {
  const notistackRef = useRef();

  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      preventDuplicate
      ariaAttributes={{ 'aria-label': 'toast' }}
      ref={notistackRef}
      maxSnack={3}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      Components={{
        success: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
      iconVariant={{
        error: (
          <CancelOutlinedIcon sx={{ fontSize: 22, paddingRight: '0.5rem' }} />
        ),
        info: (
          <ErrorOutlineIcon sx={{ fontSize: 22, paddingRight: '0.5rem' }} />
        ),
        success: (
          <CheckCircleOutlineIcon
            sx={{ fontSize: 22, paddingRight: '0.5rem' }}
          />
        ),
        warning: (
          <WarningRoundedIcon sx={{ fontSize: 22, paddingRight: '0.5rem' }} />
        ),
      }}
      action={(key) => (
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={onClickDismiss(key)}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node,
};

export default ToastProvider;
